import React from 'react';

import { ISanityImage } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';
import { useLogger } from 'state/logger';
import { useUIContext } from 'state/ui';

interface IRawPictureProps {
  image: IImageFragment | ISanityImage;
  alt: string;
  className?: string;
}

/**
 * RawPicture
 *
 * Similar to Picture, this fetches a Sanity img. The difference is that by not passing URL params (such as height & width)
 * on the img request, we bypass the Sanity image pipeline, retrieving the image as-is.
 * (https://www.sanity.io/docs/presenting-images#the-sanity-image-pipeline-QE5jDB7y)
 */
export const RawPicture: React.FC<IRawPictureProps> = ({ image, alt, className, ...props }) => {
  const { imageBuilder } = useUIContext();
  const logger = useLogger();

  const imgSrc = imageBuilder.image(image).url();
  if (!imgSrc) {
    logger.warn(`Unable to build img src from image: ${image}`);
    return null;
  }

  return <img src={imgSrc} alt={alt} className={className} {...props} />;
};

export default RawPicture;
